'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    progress = require('../../progress'),
    dialog = require('../../dialog'),
    tooltip = require('../../tooltip'),
	shipping = require('./shipping'),
	tealium = require('../../../../../int_tealium/cartridge/js/tealium/tealium'),
    util = require('../../util');
var hasSentPromotableOrNonPromotable = false;
SessionAttributes = window.SessionAttributes;
var shippingMethods;
/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
}

exports.init = function () {
    util.updateselect();

    // select address from list
    $('select[name$="_singleshipping_addressList"],select[name$="_billing_addressList"]').on('change', function () {
    	var  $form;
    	if ($(this).parents('.shipping').length > 0) {
    		$form = $('.shipping .address-section');
    		if ( $('input[name$="_shippingAddress_useAsBillingAddress"]').is(':checked')) {
	        	$('input[name$="_shippingAddress_useAsBillingAddress"]').removeAttr('checked');
	        }
    	} else {
    		$form = $('.billing .address-section');
    	}
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');

        util.fillAddressFields(selectedAddress, $form);
        if ($(this).parents('.shipping').length > 0) {
        	$('.shipping').find('input[name$="_addressFields_address1"], input[name$="_addressFields_address2"]').trigger('change');
        }
    });

    $("body").off('click','input[name$="_shippingAddress_useAsBillingAddress"]').on('click','input[name$="_shippingAddress_useAsBillingAddress"]',function(){
    	if ($(this).is(':checked')) {
    		//Billing address fields are filled with shipping address fields on selecting this checkbox true.
    		$('select[name$="_billing_addressList"]').val($('select[name$="_singleshipping_addressList"]').val()).trigger('change');
    		//During triggering above code, checkbox is being unchecked and hence made to checked state to display user.
    		$('input[name$="_shippingAddress_useAsBillingAddress"]').prop('checked', true);
        	$('input[name$="_shippingAddress_useAsBillingAddress"]').val("true");
    	}
    });

    if($('.row-header').closest('.tab-section.showcontent').find('.toggle-content').is(':visible')) {
        $('.row-header').closest('.tab-section.showcontent').find('.arrow-img').addClass('expanded');
    }

    $('.shipping .address-actions a').on('click keypress',function(e){
			if(!e.isTrigger && e.which != 1 && e.which != 13 ){
				return;
			}
    	 e.preventDefault();
    	 var url = $('.edit-link.editshipping').data('href');
    	 if ($(this).hasClass('shipping-add-edit')) {
         	url = util.appendParamToURL(url, 'type', 'editaddress');
     	} else if ($(this).hasClass('shipping-add-new')) {
     		url = util.appendParamToURL(url, 'type', 'addaddress');
     	}
    	$('.edit-link.editshipping').data('href', url);
    	$('.edit-link.editshipping').trigger('click');
    });

   /* // add generic toggle functionality
    $("#primary").find('.toggle').next('.toggle-content').hide();
    $('#primary').off("click",".toggle").on("click",".toggle",function() {
        $(this).toggleClass('expanded').next('.toggle-content').toggle();
    });*/

    $('.billing .address-actions a,.billing .newcreditcard').on('click',function(e){
    	e.preventDefault();
    	var url = $('.billing .edit-link').data('href');
    	if ($(this).hasClass('newcreditcard')) {
    		url = util.appendParamToURL(url, 'type', 'payment');
    		if ($('.spc-express-checkout').length > 0 ) {
                url = util.appendParamToURL(url, 'checkout', 'express');
            }
    	}

        if ($(this).hasClass('editaddress')) {
        	url = util.appendParamToURL(url, 'type', 'editaddress');
    	} else if ($(this).hasClass('addaddress')) {
    		url = util.appendParamToURL(url, 'type', 'addaddress');
    	}
        $('.billing .edit-link').data('href', url);
    	$('.billing .edit-link').trigger('click');
    });

    $('.shipping').on('change','input[name$="_addressFields_address1"], input[name$="_addressFields_address2"]', function(e) {
    	var isExcludedProducts = $('.po-exclude-products').val();
    	var currentvalue = $(this).val();
    	if (isExcludedProducts == 'true' && currentvalue != undefined && currentvalue != null && currentvalue != '') {
    		var exclusionValues = SitePreferences.POBOX_EXCLUSIONS;
	    	if (exclusionValues == undefined || exclusionValues == null || exclusionValues == '') {
	            return false;
	        }
	    	var exclusionList = exclusionValues.split(',');
	    	var isExclusion = false;
	    	for (var i=0;i<exclusionList.length; i++ ) {
	    		var restrictedAddress = exclusionList[i].toLowerCase();
	    		currentvalue = currentvalue.toLowerCase();
	    		if (currentvalue.indexOf(restrictedAddress) >= 0) {
	    			isExclusion = true;
	    			break;
	    		}
	    	}
	    	if (!isExclusion) {
	    		shipping.updateShippingMethodList(3);
	    		return false;
	    	}
	    	e.preventDefault();
	    	dialog.open({
	            url: Urls.poExclusion,
	            options: {
	                open: function () {
	                	$('.edit-shipping').on('click',function(e){
	                		dialog.close();
	                		$('.shipping-add-edit').trigger('click'); //SM-6697
	                	});
	                	$('.remove-tems').on('click',function(e){
	                		e.preventDefault();
	            	        var form = $(this).closest('form');
	            	        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
	            	        form.validate();
	            	        if (!form.valid()) {
	            	            return false;
	            	        }
	            	        var poURL = util.appendParamToURL(form.attr('action'), 'stepCount', '3');
	            	        ajax.load({
	            	            url: poURL,
	            	            data: form.serialize(),
	            	            method: 'POST',
	            	            callback: function (data) {
	            	            	dialog.close();
	            	            	var $summary = $('#secondary .checkout-order-summary-container');
	            	            	$summary.html($(data).filter('.minisummary').html());
	    	            	        $summary.fadeIn('fast');
	    	            	        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
	    	            	        $summary.find('.order-totals-table .order-shipping .label a').hide();
		            		        $summary.find('.rightbutton').on('click',function(){
		            		        	$('#primary').find('.spc-summary-btn:not(:disabled)').trigger('click');
		            		    	});
		            		        formPrepare.init({
		            		            formSelector: 'form[id$="express-order-submit"]',
		            		            continueSelector: '[name$="submit"]'
		            		        });
		            		        $('.basket-details').html($(data).filter('.basketinfo').html());
		            		        $('.po-exclude-products').val('false');
		            		        shipping.updateShippingMethodList();
	            	            }
	            	        });
	                	});
	                	/* PXSFCC-4495_WCAG_Modal_focus_management */
	                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
	                    	$(this).focus();
	                    });
	                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
	                }
	            }
	        });
    	}
    });

    $('.shipping').on('change',
        'select[name$="_addressFields_states_state"], input[name$="_addressFields_postal"], input[name$="_addressFields_city"], input[name$="_addressFields_zip"]',function(){
		$("#primary .tax-error-message:visible").addClass('hide');
		shipping.updateShippingMethodList(3);
    });


    $('.cvn input').on('input change',function(){
		 util.allowDigits($(this));
	});

    $('.submit-express-order').off('click', '.spc-summary-btn').on('click', '.spc-summary-btn', function (e) {
    	var cvvform = $(this).closest('form');
    	cvvform.validate();
        if (!cvvform.valid()) {
        	var $errorElement=cvvform.find('input.error,select.error').first();
        	$errorElement.focus();
        	formPrepare.completeFormMessage();
        	if ($(window).width() < 768) {
        	 $('html, body').animate({
        		 scrollTop: $errorElement.offset().top - 95
             }, 200);
        	}
            return false;
        }
		progress.show($("#main"));
		// when a user logs out as guest the _subscribeToEmail checkbox does not exist in the DOM
		if (!hasSentPromotableOrNonPromotable && $(this).closest('form').find('input[name$=_subscribeToEmail]').length > 0) {
			// SC-1136: Trigger event for opt in status on click of the place order CTA
			 if( typeof(utag_data) != 'undefined' ){
					hasSentPromotableOrNonPromotable = true;
					var addToEmailList = $(this).closest('form').find('input[name$=_subscribeToEmail]').is(':checked');
					var obj = {};
					obj.event_name = addToEmailList ? "is_promotable" : "is_not_promotable";
					obj.deal_opt_in_out_location = "Checkout Review";
					 if(obj.event_name == 'is_promotable'){
						    obj.primary_brand_email=utag_data.checkout_brand != "" ? (utag_data.checkout_brand).toUpperCase():"";
					        var addToCartBrands=utag_data.add_to_cart_brand;
					        if(addToCartBrands != null){
					        	var brandArray=[];
					        	for (var i=0;i<addToCartBrands.length;i++){
                                    // added null check for addToCartBrands[i]
					        		var brandValue = typeof addToCartBrands[i] != 'undefined' && addToCartBrands[i] != null ? addToCartBrands[i].toUpperCase() : null;
					        		if(brandArray.indexOf(brandValue) == -1){
					        			brandArray.push(brandValue);
					        		}
					        	}
					        	obj.secondary_brand_email=brandArray;
					        }
					 }
					tealium.triggerViewEvent(obj);
			 }
		}

		// Tealium checkout SMS sign-up
		if(SessionAttributes.IS_CUSTOMER_AUTHENTICATED) {
			if($(this).closest('form').find('input[name$=_smsSignUp]').length > 0 && typeof(utag_data) != 'undefined') {
				var smsSubscription = $(this).closest('form').find('input[name$=_smsSignUp]').is(':checked');
				var obj = {};
				obj.event_name = smsSubscription ? "sms_is_promotable" : "sms_is_not_promotable";
				obj.sms_opt_in_location = "Checkout Review";
				tealium.triggerEvent(obj);
			} 
		} else {
			if(util.getCookie('guestsmsoptin') != ""){
				var guestSMSSignDetails = util.getCookie('guestsmsoptin');
				var detailsArray = guestSMSSignDetails.split('|');
				var obj = {};
				obj.event_name = detailsArray[1] == 'true' ? "sms_is_promotable" : "sms_is_not_promotable";
				obj.sms_opt_in_location = detailsArray[0];
				tealium.triggerEvent(obj);
			}
		}
		var addrees1 = $('.shipping').find('input[name$="_addressFields_address1"]').val();
        var addrees2 = $('.shipping').find('input[name$="_addressFields_address2"]').val();
        var isExcludedProducts = $('.po-exclude-products').val();
        var exclusionValues = SitePreferences.POBOX_EXCLUSIONS;
        var isExclusion = false;
        if (isExcludedProducts == 'true' && exclusionValues != undefined && exclusionValues != null && exclusionValues != '') {
        	var exclusionList = exclusionValues.split(',');
	    	for (var i=0;i<exclusionList.length; i++ ) {
	    		var restrictedAddress = exclusionList[i].toLowerCase();
	    		addrees1 = addrees1.toLowerCase();
	    		if (addrees1.indexOf(restrictedAddress) >= 0) {
	    			isExclusion = true;
	    			break;
	    		}
	    	}
	    	if (!isExclusion && addrees2 != undefined && addrees2 != null && addrees2 != '') {
	    		for (var i=0;i<exclusionList.length; i++ ) {
	    			var restrictedAddress = exclusionList[i].toLowerCase();
    	    		addrees2 = addrees2.toLowerCase();
    	    		if (addrees2.indexOf(restrictedAddress) >= 0) {
    	    			isExclusion = true;
    	    			break;
    	    		}
    	    	}
	    	}
	    }
    	if (isExclusion) {
    		dialog.open({
	            url: Urls.poExclusion,
	            options: {
	                open: function () {
	                	$('.edit-shipping').on('click',function(e){
	                		dialog.close();
	                		$('.shipping-add-edit').trigger('click'); //SM-6697
	                	});
	                	$('.remove-tems').on('click',function(e){
	                		e.preventDefault();
	            	        var form = $(this).closest('form');
	            	        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
	            	        form.validate();
	            	        if (!form.valid()) {
	            	            return false;
	            	        }
	            	        var poURL = util.appendParamToURL(form.attr('action'), 'stepCount', '3');
	            	        ajax.load({
	            	            url: poURL,
	            	            data: form.serialize(),
	            	            method: 'POST',
	            	            callback: function (data) {
	            	            	dialog.close();
	            	            	var $summary = $('#secondary .checkout-order-summary-container');
	            	            	$summary.html($(data).filter('.minisummary').html());
	    	            	        $summary.fadeIn('fast');
	    	            	        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
	    	            	        $summary.find('.order-totals-table .order-shipping .label a').hide();
		            		        $summary.find('.rightbutton').on('click',function(){
		            		        	$('#primary').find('.spc-summary-btn:not(:disabled)').trigger('click');
		            		    	});
		            		        formPrepare.init({
		            		            formSelector: 'form[id$="express-order-submit"]',
		            		            continueSelector: '[name$="submit"]'
		            		        });
		            		        $('.basket-details').html($(data).filter('.basketinfo').html());
		            		        $('.po-exclude-products').val('false');
		            		        shipping.updateShippingMethodList();
	            	            }
	            	        });
	                	});
	                	/* PXSFCC-4495_WCAG_Modal_focus_management */
	                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
	                    	$(this).focus();
	                    });
	                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
	                }
	            }
	        });
    		progress.hide();
	    	return false;
	    } else {
	    	if ($('input[name$=_selectedPaymentMethodID]:checked').val() === 'PayPal') {
				$('.submit-express-order').attr('action',Urls.paypalIncontext);
				progress.hide();
	            return true;
	        } else {
				if ($('#ecoship-checkbox').length) {
					$('input[name="isEcoshipEnabled"]').val($('#ecoship-checkbox').prop("checked"));
					$('input[name="ecoshipDate"]').val($('.ecoship-delivery-date').attr('data-ecoship-date'));
				} else {
					$('input[name="isEcoshipEnabled"]').val('false');
					$('input[name="ecoshipDate"]').val('');
				}
				$('.submit-express-order').attr('action',Urls.expressSubmit);
				return true;
			}
		}
    });

    giftMessageBox();
    shipping.updateShippingMethodList(3,false);

    $('body').off('change','.card-list .differedBilling .input-checkbox').on('change','.card-list .differedBilling .input-checkbox',function(e){
    	if($(this).is(':checked')){
    		$('.differed-billing-content ').removeClass('hide');
    	} else {
    		$('.differed-billing-content ').addClass('hide');
    	}
	});

    //express checkout view more less in diferred billing
    var diferredbillingcharacters = 273;
    if($(window).width() < 767) {
    	diferredbillingcharacters = 178;
    }
    util.veiwmorelesswithellipse(diferredbillingcharacters);


    formPrepare.init({
        formSelector: 'form[id$="express-order-submit"]',
        continueSelector: '[name$="submit"]'
    });
    //Address validation
    require('../../addressvalidation').init();
};